import moment from 'moment'
export default {
  /* eslint-disable eqeqeq */
  data: () => ({}),
  methods: {
    startDuration (item) {
      let values = {task_id: item.id, begin: moment().format('YYYY-MM-DD HH:mm:ss'), end: moment().format('YYYY-MM-DD HH:mm:ss'), id_text: item.id_text, active: true, httpDB: true}
      // Passado o httpDB para true para iniciar o tempo no banco
      // E depois passar no socket como false para não incluir no banco pelas outras abas
      this.$store.commit('stopWatch/change_values', values)
      this.$socket.emit('generalEvent', {
        data: Object.assign(values, {httpDB: false}),
        responseEvent: 'changeStopWatch',
        room: `user${this.$auth.user().id}`
      })
    },
    closeDuration () {
      let values = {httpDB: true, active: false}
      this.$store.commit('stopWatch/change_values', values)
      this.$socket.emit('generalEvent', {
        data: Object.assign(values, {httpDB: false}),
        responseEvent: 'changeStopWatch',
        room: `user${this.$auth.user().id}`
      })
    },
    companyParamsTime (item) {
      let params = JSON.parse(this.$auth.user().company.params)
      // Caso tenha parametro de iniciar o tempo e o status alterado seja algum no parametro starta o tempo daquela tarefa
      if (params['startTime'] && params['startTime']['active'] && params['startTime']['status'].some((val) => { return val == item.task_status_id })) {
        let stopWatchValues = this.$store.getters[`stopWatch/values`]
        // Caso tenha uma duração rodando e a tarefa que mudou o status for a msm que está rodando, não deve alterar nada no tempo. A tratativa de parar o tempo com ids iguais é apenas quando clica no relogio
        if (!(stopWatchValues['active'] && stopWatchValues['task_id'] == item['id'])) {
          this.startDuration(item)
          // Caso tenha parametro para para o tempo e o status alterado seja algum no parametro e a tarefa esteja rodando: para o tempo da tarefa.
          // Caira no else caso o usuário tenha colocado o mesmo status tanto para iniciar como para parar o tempo
        } else {
          if (params['stopTime'] && params['stopTime']['active'] && params['stopTime']['status'].some((val) => { return val == item.task_status_id })) {
            let durationStopWatch = this.$store.getters[`stopWatch/values`] || ''
            if (durationStopWatch['active'] && durationStopWatch['task_id'] == item.id) {
              this.closeDuration()
            }
          }
        }
        // Caso tenha parametro para para o tempo e o status alterado seja algum no parametro e a tarefa esteja rodando: para o tempo da tarefa
      } else if (params['stopTime'] && params['stopTime']['active'] && params['stopTime']['status'].some((val) => { return val == item.task_status_id })) {
        let durationStopWatch = this.$store.getters[`stopWatch/values`] || ''
        if (durationStopWatch['active'] && durationStopWatch['task_id'] == item.id) {
          this.closeDuration()
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/stopWatch.js